(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saintez-cart"]) return;
  try {
    
  // Progressive enhancement only: the number input already works on its
  // own (type="number", min="0") — these buttons just save a tap on
  // mobile. Persisting the change still goes through the real form submit
  // (Update/Checkout buttons), same as if JS never ran.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sz-cart-qty-minus], [data-sz-cart-qty-plus]');
    if (!button) return;
    var wrapper = button.closest('[data-sz-cart-qty]');
    var input = wrapper ? wrapper.querySelector('[data-sz-cart-qty-input]') : null;
    if (!input) return;

    var value = parseInt(input.value, 10) || 0;
    if (button.matches('[data-sz-cart-qty-minus]')) {
      value = Math.max(0, value - 1);
    } else {
      value += 1;
    }
    input.value = value;
  });

  // "Continue shopping" should return to wherever the shopper actually
  // came from (the product/collection page they were just browsing), not
  // always the same fixed "all products" link. Real browser history is
  // the only reliable source for that — Liquid has no idea what page
  // rendered before this one. Falls back to the plain href (still a
  // real, correct destination) when there's nothing to go back to: a
  // fresh tab/direct link to /cart, or a referrer from outside this
  // store, where "back" would leave the site entirely.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-sz-cart-continue]');
    if (!link) return;
    var cameFromThisSite = document.referrer && document.referrer.indexOf(window.location.origin) === 0;
    if (cameFromThisSite && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saintez-collection-product-grid"]) return;
  try {
    
  // Progressive enhancement only: the sort form works via a plain GET
  // submit (and the <noscript> button) without this. Auto-submitting on
  // change is the only thing added here, so users with JS don't need an
  // extra click. Filter auto-submit/drawer behavior lives in
  // initCollectionFilters() (saintez-interactions.js) since it needs the
  // shared lockBodyScroll/unlockBodyScroll.
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-sz-sort-select]')) {
      event.target.closest('[data-sz-sort-form]').submit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saintez-coming-soon"]) return;
  try {
    
  // Progressive enhancement for the early-access email form: intercepts
  // the submit and POSTs it via fetch so the result (loading/success/error)
  // renders inline without a page reload. If this script never runs, or the
  // fetch itself fails, the <form> is untouched and still submits natively
  // to Shopify's real customer/newsletter endpoint — the signup always
  // works, JS is purely a smoother presentation on top of it.
  (function () {
    var form = document.getElementById('SaintezComingSoonForm');
    if (!form) return;

    function setBusy(button, busy) {
      if (!button) return;
      var label = button.querySelector('.sz-cs-form-submit-label');
      if (busy) {
        button.dataset.originalLabel = label ? label.textContent : '';
        if (label && button.dataset.loadingLabel) label.textContent = button.dataset.loadingLabel;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      } else {
        if (label && button.dataset.originalLabel) label.textContent = button.dataset.originalLabel;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }

    function showError(text) {
      var messageEl = form.querySelector('.sz-cs-form-message');
      if (!messageEl) return;
      messageEl.textContent = text;
      messageEl.id = 'SaintezCsError';
      messageEl.classList.add('sz-cs-form-message--error');
      messageEl.setAttribute('role', 'alert');

      var emailInput = form.querySelector('#SaintezCsEmail');
      if (emailInput) {
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.setAttribute('aria-describedby', 'SaintezCsError');
        emailInput.focus();
      }
    }

    form.addEventListener('submit', function (event) {
      if (form.classList.contains('is-submitting') || form.classList.contains('is-submitted')) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      form.classList.add('is-submitting');

      var formWrap = form.querySelector('.sz-cs-form-wrap');
      var submitButton = form.querySelector('.sz-cs-form-submit');
      if (formWrap) formWrap.classList.add('sz-cs-form-wrap--loading');
      setBusy(submitButton, true);

      // URLSearchParams (not a raw FormData body) so the request's
      // Content-Type matches the form's own enctype
      // (application/x-www-form-urlencoded) rather than defaulting to
      // multipart/form-data.
      fetch(form.action, {
        method: 'POST',
        body: new URLSearchParams(new FormData(form)),
        headers: { Accept: 'text/html' },
      })
        .then(function (response) {
          return response.text().then(function (html) {
            return { html: html, ok: response.ok };
          });
        })
        .then(function (result) {
          var doc = new DOMParser().parseFromString(result.html, 'text/html');
          var successEl = doc.querySelector('#SaintezComingSoonForm .sz-cs-success');

          if (result.ok && successEl && formWrap) {
            formWrap.classList.remove('sz-cs-form-wrap--loading');
            formWrap.innerHTML = successEl.outerHTML;
            form.classList.remove('is-submitting');
            form.classList.add('is-submitted');
            var success = formWrap.querySelector('.sz-cs-success');
            if (success) success.focus();
            return;
          }

          setBusy(submitButton, false);
          if (formWrap) formWrap.classList.remove('sz-cs-form-wrap--loading');
          form.classList.remove('is-submitting');

          var errorEl = result.ok ? doc.querySelector('#SaintezComingSoonForm #SaintezCsError') : null;
          if (errorEl) {
            showError(errorEl.textContent.trim());
          } else {
            // Response didn't come back as our own re-rendered section at
            // all (e.g. an unexpected non-2xx response) — surface a plain
            // fallback rather than leaving the visitor staring at a form
            // that silently stopped loading with no explanation.
            showError((submitButton && submitButton.dataset.genericError) || '');
          }
        })
        .catch(function () {
          // Network failure: fall back to a real, non-JS submission so the
          // signup still goes through instead of silently failing.
          form.classList.remove('is-submitting');
          setBusy(submitButton, false);
          if (formWrap) formWrap.classList.remove('sz-cs-form-wrap--loading');
          form.submit();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saintez-product"]) return;
  try {
    
  // Two page-only, closure-free behaviors that don't need bindOptionPills'
  // internals (that piece — gallery reorder + sticky form sync on variant
  // change — lives in initProductPage(), saintez-interactions.js, since it
  // has to run inside the same closure as bindOptionPills to reach it):
  // the mobile swipe counter, and showing/hiding the sticky bar once the
  // real add-to-cart button leaves the viewport.
  document.addEventListener('DOMContentLoaded', function () {
    var gallery = document.querySelector('[data-sz-product-gallery]');
    var counter = document.querySelector('[data-sz-gallery-counter]');
    var items = gallery ? gallery.querySelectorAll('[data-sz-gallery-item]') : [];

    if (gallery && counter && items.length > 1) {
      var mobileQuery = window.matchMedia('(max-width: 749px)');
      var updateCounter = function () {
        if (!mobileQuery.matches) return;
        var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        index = Math.max(0, Math.min(index, items.length - 1));
        counter.textContent = index + 1 + ' / ' + items.length;
      };
      var ticking = false;
      gallery.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            updateCounter();
            ticking = false;
          });
        },
        { passive: true }
      );
      window.addEventListener('resize', updateCounter);
      updateCounter();
    }

    var stickyBar = document.querySelector('[data-sz-sticky-bar]');
    var anchor = document.querySelector('[data-sz-sticky-anchor]');
    if (stickyBar && anchor && 'IntersectionObserver' in window) {
      var stickyMobileQuery = window.matchMedia('(max-width: 749px)');
      var io = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var show = stickyMobileQuery.matches && !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', show);
        },
        { threshold: 0 }
      );
      io.observe(anchor);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
